import { render, staticRenderFns } from "./projects.html?vue&type=template&id=759d47e2&scoped=true&"
import script from "./projects.js?vue&type=script&lang=js&"
export * from "./projects.js?vue&type=script&lang=js&"
import style0 from "./projects.scss?vue&type=style&index=0&id=759d47e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759d47e2",
  null
  
)

export default component.exports